export default "__VITE_ASSET__1hUDWGxq__"